export const ENUM__color_bright = {
  RED: 'rgba(239, 68, 68, 0.5)',
  YELLOW: 'rgba(251, 191, 36, 0.5)',
  GREEN: 'rgba(34, 197, 94, 0.5)',
  BLUE: 'rgba(59, 130, 246, 0.5)',
  PURPLE: 'rgba(139, 92, 246, 0.5)',
  PINK: 'rgba(236, 72, 153, 0.5)',
  TEAL: 'rgba(20, 184, 166, 0.5)',
  VIOLET: 'rgba(168, 85, 247, 0.5)',
  AMBER: 'rgba(253, 186, 116, 0.5)',
  EMERALD: 'rgba(16, 185, 129, 0.5)',
  LIME: 'rgba(132, 204, 22, 0.5)',
  SKY: 'rgba(147, 197, 253, 0.5)',
  FUCHSIA: 'rgba(244, 114, 182, 0.5)',
  ROSE: 'rgba(251, 113, 133, 0.5)',
  SLATE: 'rgba(203, 213, 225, 0.5)',
  LIGHT_BLUE: 'rgba(125, 211, 252, 0.5)',
  LIGHT_YELLOW: 'rgba(253, 224, 71, 0.5)',
  LIGHT_LIME: 'rgba(190, 242, 100, 0.5)',
  LIGHT_GREEN: 'rgba(134, 239, 172, 0.5)',
  LIGHT_PINK: 'rgba(253, 164, 175, 0.5)',
  LIGHT_VIOLET: 'rgba(192, 132, 252, 0.5)',
  LIGHT_ROSE: 'rgba(251, 207, 232, 0.5)',
  CRIMSON: 'rgba(244, 63, 94, 0.5)',
  SUNFLOWER: 'rgba(250, 204, 21, 0.5)',
  CYAN: 'rgba(34, 211, 238, 0.5)',
  PASTEL_PINK: 'rgba(249, 168, 212, 0.5)',
  MINT: 'rgba(187, 247, 208, 0.5)',
  PASTEL_BLUE: 'rgba(186, 230, 253, 0.5)',
  LAVENDER: 'rgba(221, 214, 254, 0.5)',
  MANGO: 'rgba(252, 211, 77, 0.5)',
} as const;
